// src/components/Blocks/Banner/schema.js
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  fieldsetDefault: { id: 'Default', defaultMessage: 'Default' },
  image: { id: 'Image', defaultMessage: 'Immagine' },
  titleText: { id: 'Title Text', defaultMessage: '' },
  text: { id: 'Text', defaultMessage: '' },
  buttonText: { id: 'Button Text', defaultMessage: 'Testo del bottone' },
  buttonLink: { id: 'Button Link', defaultMessage: 'Link del bottone' },
  styleTextInEvidence: {
    id: 'Style testo in evidenza',
    defaultMessage: 'Stile del testo in evidenza',
  },
  chiaro: {
    id: 'chiaro',
    defaultMessage: 'Chiaro',
  },
  scuro: {
    id: 'scuro',
    defaultMessage: 'Scuro',
  },
  nosfondo: {
    id: 'nosfondo',
    defaultMessage: 'Nessuno sfondo',
  },
});

const bannerSchema = (props) => {
  const { intl } = props;

  return {
    title: 'Banner',
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.fieldsetDefault),
        fields: ['styleTextInEvidence', 'image', 'titleText', 'text', 'buttonText', 'buttonLink'],
      },
    ],
    properties: {
      styleTextInEvidence: {
        title: intl.formatMessage(messages.styleTextInEvidence),
        widget: 'select',
        choices: [
          ['nosfondo', intl.formatMessage(messages.nosfondo)],
          ['chiaro', intl.formatMessage(messages.chiaro)],
          ['scuro', intl.formatMessage(messages.scuro)],          
        ],
        default: 'nosfondo',
      },
      image: {
        title: intl.formatMessage(messages.image),
        widget: 'file',
        default: null,
      },
      titleText: {
        title: intl.formatMessage(messages.titleText),
        type: 'string',
        widget: 'text',
        default: '',
      },
      text: {
        title: intl.formatMessage(messages.text),
        type: 'string',
        widget: 'text',
        default: '',
      },
      buttonText: {
        title: intl.formatMessage(messages.buttonText),
        type: 'string',
        widget: 'text',
        default: '',
      },
      buttonLink: {
        title: intl.formatMessage(messages.buttonLink),
        //description: 'spiegazione su come usarlo',
        widget: 'url', // Cambiato a url per supportare link esterni e interni
        default: '',
      },
    },
    required: ['image'],
  };
};

export default bannerSchema;